import { useEffect, useState } from "react";
import { RoundedPlusIcon } from "../../../ui/icons/RoundedPlusIcon";
import Button from "../../../ui/molecules/button";
import { InfoBox } from "../../../ui/molecules/infoBox";
import { SelectCustom } from "../../../ui/molecules/select";
import { TableSelect } from "../../../ui/molecules/tableSelect";
import { DocumentIcon } from "../../../ui/icons/documentIcon";
import { CreateProforma, GetAllIVReimbursement, GetAllProforma, resetCreateProformaStatus, resetGetAllReimbursementStatus, setCreateProformaAssignmentId, setCreateProformaFiscalRegime, setCreateProformaInspectionIds } from "./edit/gestioneRimborsi/slice";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { IVReimbursementDTO, ReimbursementTypeEnum } from "./edit/gestioneRimborsi/dataservice/dto";
import { fiscalRegimeOptions, formatEuro, formatterDate, optionsFormatter, ProformaStatus } from "../../../utils";

export function InspectionVisitBioCostPrevision() {
    const [toView, setToView] = useState<string | null>(null)
    const dispatch = useAppDispatch()
    const reimbursementState = useAppSelector(state => state.reimbursement)
    const assignmentState = useAppSelector(state => state.assignment)
    const pmAnagraficaState = useAppSelector(state => state.PMAnagrafica)
    const [showSuccessCreateProforma, setShowSuccessCreateProforma] = useState<boolean>(false)
    const [formattedData, setFormattedData] = useState<
        { value: string; labels: (string)[] }[]
    >([]);
    const [formattedProformaData, setFormattedProformaData] = useState<
        { value: string; labels: (string)[] }[]
    >([]);
    const [inspectionIdsDisabled, setInspectionIdsDisabled] = useState<string[]>([]);
    const initialSums: { [key in ReimbursementTypeEnum]: number } = {
        [ReimbursementTypeEnum.INDENNITA_CHILOMETRICA]: 0,
        [ReimbursementTypeEnum.ALLOGGIO]: 0,
        [ReimbursementTypeEnum.VITTO]: 0,
        [ReimbursementTypeEnum.ALTRO]: 0,
        [ReimbursementTypeEnum.PEDAGGIO]: 0,
        [ReimbursementTypeEnum.TRAGHETTO]: 0,
        [ReimbursementTypeEnum.PARCHEGGIO]: 0,
        [ReimbursementTypeEnum.SERVIZI_POSTALI]: 0,
    }
    const [AllSumsByType, setAllSumsByType] = useState(initialSums)
    const [totalAmount, setTotalAmount] = useState(0)

    useEffect(() => {
        dispatch(GetAllIVReimbursement({
            itemsPerPage: 0,
            page: 0,
            assignmentId: assignmentState.assignmentIdToUpdate
        }))
        if (assignmentState.getAllInspectionVisitResponse && assignmentState.getAllInspectionVisitResponse !== undefined) {
            const data = assignmentState.getAllInspectionVisitResponse.data.map((visit, index) => ({
                value: visit.id,
                labels: [
                    formatterDate(visit.effectiveVisitDate),
                    visit.customerCompanyName
                ]
            }));
            setFormattedData(data);
            dispatch(GetAllProforma({
                itemsPerPage: 0,
                page: 0,
                assignmentId: assignmentState.assignmentIdToUpdate
            }))
        }
        dispatch(setCreateProformaAssignmentId(assignmentState.assignmentIdToUpdate))
    }, [])

    useEffect(() => {
        if (reimbursementState.createProformaRequestStatus === 'successfully') {
            setShowSuccessCreateProforma(true)
            dispatch(resetCreateProformaStatus())
            setTimeout(() => {
                setShowSuccessCreateProforma(false)
            }, 2500);
            dispatch(GetAllProforma({
                itemsPerPage: 0,
                page: 0,
                assignmentId: assignmentState.assignmentIdToUpdate
            }))
        }
    }, [reimbursementState.createProformaRequestStatus])

    useEffect(() => {
        if (reimbursementState.getAllProformaStatus === 'successfully') {
            const allInspectionIds: string[] = [];
            reimbursementState.getAllProformaResponse?.data.map((proforma) => {
                if (Array.isArray(proforma.inspectionVisitIds)) {
                    allInspectionIds.push(...proforma.inspectionVisitIds);
                }
            })
            const dataProforma = reimbursementState.getAllProformaResponse?.data.map((proforma) => ({
                value: proforma.id ?? '',
                labels: [
                    formatterDate(proforma.creationDate),
                ]
            })) ?? [];
            setFormattedProformaData(dataProforma);
            setInspectionIdsDisabled(allInspectionIds);
        }
    }, [reimbursementState.getAllProformaStatus])

    useEffect(() => {
        if (reimbursementState.getAllReimbursementStatus === 'successfully') {
            dispatch(resetGetAllReimbursementStatus())
            const data: IVReimbursementDTO[] = reimbursementState.getAllReimbursementResponse?.data || []

            // Inizializza le somme a zero
            const newSumsByType: { [key in ReimbursementTypeEnum]: number } = { ...initialSums }

            data.forEach((item) => {
                const { reimbursementType, amount, kilometresTravelled, day } = item

                if (reimbursementType === ReimbursementTypeEnum.INDENNITA_CHILOMETRICA) {
                    if (kilometresTravelled && day) {
                        const dateObj = new Date(day)
                        const thresholdDate = new Date('2022-12-31')
                        const tariffa = dateObj > thresholdDate ? 0.40 : 0.35
                        const calculatedAmount = kilometresTravelled * tariffa
                        newSumsByType[reimbursementType] += calculatedAmount
                    }
                } else if (reimbursementType && amount) {
                    newSumsByType[reimbursementType] += amount
                }
            })
            const calculatedTotalAmount = Object.values(newSumsByType).reduce((acc, curr) => acc + curr, 0)
            setAllSumsByType(newSumsByType)
            setTotalAmount(calculatedTotalAmount)
        }
    }, [
        reimbursementState.getAllReimbursementStatus,
        dispatch
    ])


    return (
        <div className="assignment-container">
            <div style={{ padding: '24px' }}>

                <div className="text-left pb-5">
                    <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                    <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                    <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Previsione costi per l'incarico</span>
                </div>

                <div className="pb-[50px]">
                    <InfoBox
                        color="green"
                        table={{
                            title: null,
                            headers: [
                                'Numero Totale Visite',
                                'Totale Richieste Rimborso Km',
                                'Totale Richiesta Rimborso Alloggio',
                                'Totale Richieste Rimborso Vitto',
                                'Totale Richieste Rimborso Altre Spese',
                                'Totale Richieste Rimborso Pedaggio',
                                'Totale Richieste Rimborso Traghetto',
                                'Totale Richieste Rimborso Parcheggio',
                                'Totale Richieste Rimborso Spese Postali',
                                'Totale Richieste Rimborsi',
                                "Totale Rimborso Visite Per l'incarico"
                            ],
                            values: [
                                [
                                    assignmentState.getAllInspectionVisitResponse ? assignmentState.getAllInspectionVisitResponse.data.length : '0',
                                    formatEuro(AllSumsByType.INDENNITA_CHILOMETRICA) + " €",
                                    formatEuro(AllSumsByType.ALLOGGIO) + " €",
                                    formatEuro(AllSumsByType.VITTO) + " €",
                                    formatEuro(AllSumsByType.ALTRO) + " €",
                                    formatEuro(AllSumsByType.PEDAGGIO) + " €",
                                    formatEuro(AllSumsByType.TRAGHETTO) + " €",
                                    formatEuro(AllSumsByType.SERVIZI_POSTALI) + " €",
                                    formatEuro(AllSumsByType.SERVIZI_POSTALI) + " €",
                                    formatEuro(totalAmount) + " €",
                                    '0.00 €',
                                ],
                                [
                                    'Totale',
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    formatEuro(totalAmount) + " €",
                                ]
                            ]
                        }}
                    />
                </div>

                <div className="pb-5">
                    <div className="text-left">
                        <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                        <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Genera nota proforma per l'incarico</span>
                    </div>
                </div>
                {
                    (showSuccessCreateProforma) &&

                    <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            Proforma Generata correttamente.
                        </span>
                    </div>
                }
                <div className="pb-5">
                    <TableSelect
                        type="checkbox"
                        headers={['Data Visita', 'Cliente']}
                        data={formattedData}
                        onChange={(values) => {
                            const filteredValues = (values as string[]).filter(
                                (v) => !inspectionIdsDisabled.includes(v)
                            );
                            dispatch(setCreateProformaInspectionIds(filteredValues));
                        }}
                        value={inspectionIdsDisabled ? inspectionIdsDisabled : []}
                        disabledValues={inspectionIdsDisabled ? inspectionIdsDisabled : []}
                    />
                </div>

                <div className="pb-5">
                    <div className="text-left assignment-text-content">
                        Scegli il regime fiscale
                    </div>
                    <SelectCustom
                        placeholder=""
                        options={fiscalRegimeOptions}
                        defaultValue={pmAnagraficaState.getByIdAnagraphicRequest.fiscalRegime}
                        onChange={(value) => dispatch(setCreateProformaFiscalRegime(value))}
                    />
                </div>

                <div className="pb-[50px]" style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="solid"
                        color="dimgrey"
                        iconPosition="left"
                        icon={<RoundedPlusIcon />}
                        size="md"
                        onClick={() => dispatch(CreateProforma(reimbursementState.createProformaRequest))}
                        label="Genera Proforma"
                    />
                </div>

                <div className="text-left pb-5">
                    <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                    <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                    <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Proforme generate</span>
                </div>

                <div>
                    <table id="users-table" className="w-[100%]">
                        <thead className="h-[52px] uppercase">
                            <tr>
                                <th style={{ borderTopLeftRadius: '8px' }}>Data Proforma</th>
                                <th>Visualizza</th>
                                <th style={{ borderTopRightRadius: '8px' }}>Stato</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reimbursementState.getAllProformaResponse?.data.map((proforma, index) =>
                                    <tr
                                        key={index}
                                        style={{
                                            color: '#4D797F',
                                            background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                        }}
                                    >
                                        <td>
                                            {
                                                formatterDate(proforma.creationDate)
                                            }
                                        </td>
                                        <td></td>
                                        <td>
                                            {
                                                optionsFormatter(proforma.status, ProformaStatus)
                                            }
                                        </td>
                                    </tr>

                                )
                            }
                        </tbody>
                    </table>
                    {/* <TableSelect
                        type="checkbox"
                        headers={['Data Proforma', 'Visualizza']}
                        data={formattedProformaData}
                        onChange={(values) => {
                            //settare valori per chiamata a backend
                            dispatch(setCreateProformaInspectionIds(values))
                        }}
                        value={inspectionIdsDisabled ? inspectionIdsDisabled : []}
                    /> */}
                </div>

                <div className="pt-5 pb-5" style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                    <Button
                        disabled={toView === null}
                        variant="outline"
                        color="dimgrey"
                        size="md"
                        iconPosition="left"
                        icon={<DocumentIcon />}
                        label="Visualizza Proforma"
                    />
                </div>
            </div>
        </div>
    )
}